import { apiClient } from './client';

export interface QuestionOption {
  score: number;
  text: string;
}

export interface Question {
  code: string;
  dimension: string;
  indicator: string;
  questionText: string;
  weight: number;
  hasNa: boolean;
  isReverse: boolean;
  isCheck: boolean;
  sortOrder?: number;
  options: QuestionOption[];
}

export interface Diagnosis {
  id: string;
  companyName: string | null;
  industry: string | null;
  scale: string | null;
  revenue: string | null;
  phone: string | null;
  status: string;
  totalScore: number | null;
  grade: string | null;
  dimensionScores: Record<string, number> | null;
  createdAt?: string;
  submittedAt?: string | null;
  answers?: { questionCode: string; score: number }[];
}

export async function getQuestions(): Promise<Question[]> {
  const res = await apiClient.get<Question[]>('/diagnosis/questions');
  return res.data;
}

export async function createDiagnosis(data?: {
  companyName?: string;
  industry?: string;
  scale?: string;
  revenue?: string;
  phone?: string;
}): Promise<Diagnosis> {
  const res = await apiClient.post<Diagnosis>('/diagnosis', data ?? {});
  return res.data;
}

export async function saveAnswers(id: string, answers: { questionCode: string; score: number }[]): Promise<{ saved: number }> {
  const res = await apiClient.put<{ saved: number }>(`/diagnosis/${id}/answers`, { answers });
  return res.data;
}

export async function submitDiagnosis(
  id: string,
  data?: { companyName?: string; industry?: string; scale?: string; revenue?: string; phone?: string },
): Promise<Diagnosis> {
  const res = await apiClient.post<Diagnosis>(`/diagnosis/${id}/submit`, data ?? {});
  return res.data;
}

export async function getDiagnosis(id: string): Promise<Diagnosis> {
  const res = await apiClient.get<Diagnosis>(`/diagnosis/${id}`);
  return res.data;
}

export const DIMENSION_NAMES: Record<string, string> = {
  strategy: '战略与组织力',
  process: '业务流程数字化',
  technology: '技术与基础设施',
  data: '数据能力',
  talent: '人才与文化',
};

export const DIMENSION_ORDER = ['strategy', 'process', 'technology', 'data', 'talent'];
